(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "normalizr", "@braindate/util/lib/assert", "./locationAssertions", "../schema"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("normalizr"), require("@braindate/util/lib/assert"), require("./locationAssertions"), require("../schema"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.normalizr, global.assert, global.locationAssertions, global.schema);
    global.locationNormalization = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _normalizr, _assert, _locationAssertions, _schema) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.hydrateLocation = hydrateLocation;
  _exports.hydrateLocations = hydrateLocations;
  _exports.normalizeLocation = normalizeLocation;
  _exports.normalizeLocations = normalizeLocations;

  /**
   * Normalize an location
   * @param   {Location} location - Location to normalize
   * @returns {number} data.result - Id of the location
   * @returns {NormalizedData<number>} data.entities - Normalized data entities
   *
   * @throws Will throw an exception if parameter is not an object
   */
  function normalizeLocation(location) {
    (0, _locationAssertions.assertLocation)(location);
    return (0, _normalizr.normalize)(location, _schema.locationSchema);
  }

  /**
   * Normalize locations
   * @param   {Array<Location>} locations - Locations to normalize
   * @returns {Array<number>} data.result - Ids of the locations
   * @returns {NormalizedData<Array<number>>} data.entities - Normalized data
   * entities
   *
   * @throws Will throw an exception if parameter is not an array
   */
  function normalizeLocations(locations) {
    (0, _assert.assertArray)(locations, "locations");
    return (0, _normalizr.normalize)(locations, _schema.locationsSchema);
  }

  /**
   * Denormalize an location
   * @param   {number} id - Id of the location
   * @param   {Entities} entities - Normalized data entities
   * @returns {Location} Denormalized location
   *
   * @throws Will throw an exception if parameters are invalid
   */
  function hydrateLocation(id, entities) {
    (0, _assert.assertNumber)(id, "id");
    (0, _assert.assertObject)(entities, "entities");
    return (0, _normalizr.denormalize)(id, _schema.locationSchema, entities);
  }

  /**
   * Denormalize locations
   * @param   {Array<number>} ids - Ids of the locations
   * @param   {Entities} entities - Normalized data entities
   * @returns {Array<Location>} Denormalized locations
   *
   * @throws Will throw an exception if parameters are invalid
   */
  function hydrateLocations(ids, entities) {
    (0, _assert.assertArray)(ids, "ids");
    (0, _assert.assertObject)(entities, "entities");
    return (0, _normalizr.denormalize)(ids, _schema.locationsSchema, entities);
  }
});